<template lang="pug">
    div.summaryCard(:class="{ muted }")
        div.value {{ value }}
        div.sub(v-if="sub") {{ sub }}
        div.label {{ label }}
        div.hint(v-if="hint") {{ hint }}
</template>

<script>
    import VueTypes from 'vue-types';

    export default {
        props: {
            label: VueTypes.string.def(''),
            value: VueTypes.oneOfType([String, Number]).def(''),
            sub: VueTypes.string.def(''),
            hint: VueTypes.string.def(''),
            muted: VueTypes.bool.def(false)
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../../assets/style/_variables.styl";

    .summaryCard
        height: 100%
        padding: 18px 20px
        border-radius: 10px
        background: rgba(255, 255, 255, 0.1)
        box-shadow: 0 0 15px rgba(0, 0, 0, 0.1)
        color: $theme.white

        &.muted .value
            opacity: 0.45

    .value
        font-size: 34px
        font-weight: 700
        line-height: 1.1

    .sub
        margin-top: 2px
        font-size: 13px
        font-weight: 700
        color: $theme.action

    .label
        margin-top: 6px
        font-size: 15px
        font-weight: 700
        text-transform: uppercase
        letter-spacing: 0.4px
        color: $theme.action

    .hint
        margin-top: 4px
        font-size: 13px
        opacity: 0.75
</style>
